import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
import withLoader from "../../layouts/WithLoader";
import { TextField } from "@material-ui/core";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useState } from "react";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import BCService from "../../../services/BC";
import SalesService from "../../../services/SellingService";






const PayementAvanceBillEnLigneFN=({startLoading,stopLoading})=>{
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const [openInfoAlert, setOpenInfoAlert] = useState(false);
    const [infoAlertText, setInfoAlertText] = useState();
    const [amount, setAmount] = useState();

    const handleInfoClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenInfoAlert(false);
    };

    const handleEroorClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenErrorAlert(false);
    };
    const changeAmount = (event) => {
        setAmount(event.target.value);
    };
    const payerBill = (e) => {
        const url = window.location.pathname.split("/")[1];
        if (url === "payerBill") {
          if (amount === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : le montant est vide ");
            }  else if (localStorage.getItem("banqueAccount") == null) {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Merci de choisir un compte bancaire ");
            } else {
                let payementModel = {
                    idUser: getCurrentUserId(),
                    idDocument: parseInt(localStorage.getItem("idBill")),
                    isAvanceOrTotalPayement: 0,
                    isFactureOrBDC: 1,
                    typePayement: 1,
                    ammountPayed: amount,
                    urlFile: "any",
                    banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
                };
                startLoading();
                BCService.payFactureOrBDC(payementModel)
                    .then((response) => {
                        if (response.data["error"]) {

                        } else {
                            setTimeout(() => {
                                window.location.reload(true);
                            }, 2000);
                        }
                    })
                    .catch((error) => {
                        setTimeout(() => {
                            window.location.reload(true);
                        }, 2000);
                    }).finally(() => {
                        stopLoading();
                    });
            }
        } else {
           if (amount === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : le montant est vide ");
            } else if (localStorage.getItem("banqueAccount") == null) {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Merci de choisir un compte bancaire ");
            } else {
                let payementModel = {
                    idUser: getCurrentUserId(),
                    idDocument: parseInt(localStorage.getItem("idBill")),
                    isAvanceOrTotalPayement: 0,
                    isFactureOrBDC: 1,
                    typePayement: 1,
                    ammountPayed: amount,
                    urlFile: "any",
                    banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
                };
                startLoading();
                SalesService.payFactureOrBDC(payementModel)
                    .then((response) => {
                        console.log(response);
                        if (response.data["error"]) {
                        } else {
                            setTimeout(() => {
                                window.location.reload(true);
                            }, 2000);
                        }
                    })
                    .catch((error) => {
                        console.log("error", error); 
                    })
                    .finally(() => {
                        stopLoading();
                    });
            }
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <label>Payement En ligne </label>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <label>Montant : </label>
                    <input
                        type="number"
                        min="0"
                        step="0.1"
                        max={localStorage.getItem("restToPay")}
                        class="form-control"
                        name="amount"
                        value={amount}
                        onChange={changeAmount}
                    />
                </div>

                <div className="col-8">
                    <label>Compte bancaire </label>
                    <ListBanquesToPayement type={1} />
                </div>
                <br />
                <div class="col-12">
                    <button
                        type="submit"
                        onClick={payerBill}
                        className="btn btn-dark float-right"
                    >
                        Payer
                    </button>
                </div>
            </div>
            <Snackbar
                open={openErrorAlert}
                autoHideDuration={2000}
                onClose={handleEroorClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleEroorClose} severity="error">
                    {errorAlertText}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openInfoAlert}
                autoHideDuration={4000}
                onClose={handleInfoClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert onClose={handleInfoClose} severity="info">
                    {infoAlertText}
                </Alert>
            </Snackbar>
        </>
    );



}

export default withLoader(PayementAvanceBillEnLigneFN)